import React from "react";

export interface ToastMessage {
  id: string;
  message: string;
  variant: "success" | "danger" | "warning" | "info";
}

interface ToastContextType {
  showToast: (message: string, variant?: ToastMessage["variant"]) => void;
}

export const ToastContext = React.createContext<ToastContextType>(null!);

export function useToast() {
  return React.useContext(ToastContext);
}
